import AxiosService from '../AxiosService';
import { apiUrl, queryString } from '../config/globals';

export const requestStartUpList = (data, params) => AxiosService.post(`${apiUrl('startup-request', 'private')}/search?${queryString(params)}`, data);

export const requestStartUp = (data) => AxiosService.post(`${apiUrl('startup-request', 'private')}/save`, data);

export const viewRequestStartUp = (data) => AxiosService.get(`${apiUrl('startup-request', 'private')}/view?${queryString(data)}`);

export const updateRequestStartUp = (data) => AxiosService.put(`${apiUrl('startup-request', 'private')}/update`, data);
